import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import ChangePasswordPage from './ChangePasswordPage';

const ChangePasswordRoute: FuseRouteItemType = {
  path: 'password/reset',
  element: <ChangePasswordPage />,
  auth: AUTH_ROLES.onlyGuest, // []
};

export default ChangePasswordRoute;
